import { createFeatureSelector, createSelector } from '@ngrx/store';
import { DatasetReviewState } from './reducer';

export const getDatasetReviewState = createFeatureSelector<DatasetReviewState>('datasetReviewState');
export const getCurrentDataset = createSelector(getDatasetReviewState, state => state.currentDataset);
export const getSelectedConflictGroup = createSelector(getDatasetReviewState, state => state.selectedConflictGroup);
export const getSelectedConflictFilters = createSelector(getDatasetReviewState, state => state.selectedConflictFilters);
export const getSortedParentIds = createSelector(getDatasetReviewState, state => state.sortedParentIds);
export const getConflictReport = createSelector(getDatasetReviewState, state => state.conflictReport);

export const areAllConflictGroupsSelected = createSelector(getDatasetReviewState, state => state.includeAllSearchResults);

export const getConflictIds = createSelector(getDatasetReviewState, state => {
  if (state.conflictReport && state.conflictReport.conflictGroups && state.conflictReport.conflictGroups.length > 0) {
    const conflictIds = [];
    state.conflictReport.conflictGroups.forEach(conflict => {
      conflictIds.push(`${conflict.parent.paragraphId}-${conflict.parent.paragraphId}`);
      conflict.childConflicts.forEach(child => {
        conflictIds.push(`${conflict.parent.paragraphId}-${child.paragraphId}`);
      });
    });
    return conflictIds;
  }
  return [];
});

export const bulkSelectedConflictCount = createSelector(getDatasetReviewState, state =>
  state.includeAllSearchResults
    ? state.conflictReport.filteredTotalConflicts - state.includeAllSearchResultsExcludedParagraphIds.length
    : state.explicitlySelectedParagraphIds.length,
);

export const implicitlySelectedCurrentPageDocumentIds = createSelector(
  getDatasetReviewState,
  getConflictIds,
  (state, conflictIds) => {
    return (
      conflictIds &&
      conflictIds.filter(
        conflictId =>
          (state.includeAllSearchResults && !state.includeAllSearchResultsExcludedParagraphIds.includes(conflictId)) ||
          state.explicitlySelectedParagraphIds.includes(conflictId),
      )
    );
  },
);

export const areAllCurrentPageDocumentsSelected = createSelector(
  getDatasetReviewState,
  getConflictIds,
  implicitlySelectedCurrentPageDocumentIds,
  (state, conflictIds, implicitlySelected) => {
    return state.conflictReport && state.conflictReport.conflictGroups
      ? state.conflictReport.conflictGroups.length > 0 && conflictIds.every(c => implicitlySelected.includes(c))
      : null;
  },
);
